import { useState } from "react";
import { X, Plus } from "lucide-react";

export const BlockedDates = ({ dates, onChange }) => {
  const [d, setD] = useState("");
  const add = () => {
    if (!d || dates.includes(d)) return;
    onChange([...dates, d].sort());
    setD("");
  };
  return (
    <div className="rounded-2xl border border-border bg-white p-4" data-testid="blocked-dates">
      <p className="text-sm text-muted mb-3">Giorni in cui non ricevi (ferie, impegni): nessuno slot sarà prenotabile.</p>
      <div className="flex flex-wrap gap-2 mb-3">
        {dates.length === 0 && <span className="text-xs text-muted/70">Nessun giorno bloccato</span>}
        {dates.map((x) => (
          <span key={x} className="inline-flex items-center gap-1 rounded-full bg-clay/15 text-clay-dark px-3 py-1 font-mono text-sm">
            {x}
            <button type="button" aria-label={`Sblocca ${x}`} data-testid={`remove-blocked-${x}`} onClick={() => onChange(dates.filter((y) => y !== x))} className="hover:text-ink"><X size={13} /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input type="date" value={d} onChange={(e) => setD(e.target.value)} data-testid="blocked-date-input" className="rounded-xl border border-border px-3 py-2 text-sm font-mono text-ink outline-none focus:border-pine" />
        <button type="button" onClick={add} data-testid="blocked-date-add" className="inline-flex items-center gap-1 rounded-full border border-clay text-clay-dark px-4 py-2 text-sm font-medium hover:bg-clay hover:text-white transition-colors"><Plus size={14} /> Blocca giorno</button>
      </div>
    </div>
  );
};
